interface CheckoutNavbarTranslationModel {
    backButtonLabel: string;
}

const defaultCheckoutNavbarTranslation: Required<CheckoutNavbarTranslationModel> = {
    backButtonLabel: 'Powrót',
};

export { type CheckoutNavbarTranslationModel, defaultCheckoutNavbarTranslation };
